<template>
  <v-container grid-list-md>
    <h3>スケジュール</h3>
    <v-card>
      <v-card-text>
        <v-layout v-for="(sch, i) in schedules" :key="i">
          <v-flex xs10 sm4>
            <div>{{sch.name}}</div>
            <!-- <v-text-field :value="sch.name" solo readonly></v-text-field> -->
          </v-flex>
          <v-flex xs10 sm4>
            <div>{{toFormattedDatetime(sch.datetime)}}</div>
          </v-flex>
          <v-flex xs2 sm1 v-if="auths.includes('EditSurveySchedules')">
            <v-btn icon @click="editItem(sch)">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{selectedName}}</v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout>
              <v-flex md12>
                <input-datetime v-model="selectedDatetime" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">キャンセル</v-btn>
          <v-btn @click="updateSchedule()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import {
  unixtimeToFormattedDate,
  FormattedDateTounixtime,
  unixtimeToFormattedDatetime,
  unixtimeToDate
} from "@/utils/datetime.js";
import db from "@/components/firebaseInit";
import inputDatetime from "@/components/inputDatetime";
import { mapGetters } from "vuex";

export default {
  components: { inputDatetime },
  props: {
    survey: {},
    schedules: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dialog: false,
      selectedDatetime: 0,
      selectedName: "",
      selectedKey: "",
      surveyDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
    };
  },
  computed: {
    ...mapGetters("auth", ["auths"]),
  },
  methods: {
    editItem(sch) {
      this.selectedName = sch.name;
      this.selectedKey = sch.key;
      this.selectedDatetime = sch.datetime;
      this.action = "update";
      this.dialog = true;
    },
    toFormattedDatetime: unixtimeToFormattedDatetime,
    async updateSchedule() {
      await this.surveyDbRef
        .update({ [this.selectedKey]: this.selectedDatetime })
        .catch(e => {
          console.error("There was an error while updating the schedule:'", e);
        });
      this.dialog = false;
    }
  },
};
</script>